export enum FireblockGroupByKeys {
  VAULT = "Vault",
  ASSET = "Asset",
  TYPE = "Type",
  TYPE_ASSET = "Type-Asset",
}
